<template>
  <div>
    <vue-element-loading :active="visible" :is-full-screen="true" />
    <form @submit.prevent="sendOtp" v-if="step === 1">
      <div class="auth-title">Forgot Password?</div>
      <div class="auth-subtext">Enter your email address and we'll send you an OTP to reset your password.</div>
      
      <va-input
        v-model="email"
        type="email"
        :label="$t('auth.email')"
        :error="!!emailErrors.length"
        :error-messages="emailErrors"
        style="color:black!important"
      />
      <div v-if="msg" class="auth-error-message">{{msg}}</div>
      <div class="d-flex justify--center mt-4">
        <button type="submit" class="auth-btn">Send OTP</button>
      </div>
      <div class="d-flex justify--center mt-3">
        <router-link class="back-link" :to="{name: 'login'}">← Back to Login</router-link>
      </div>
    </form>

    <form @submit.prevent="verifyOtp" v-if="step === 2">
      <div class="auth-title">Verify OTP</div>
      <div class="auth-subtext">Please enter the One-Time Password sent to your email.</div>
      
      <va-input
        v-model="otp"
        type="text"
        label="Enter OTP"
        :error="!!otpErrors.length"
        :error-messages="otpErrors"
        style="color:black!important"
      />
      <div v-if="msg" class="auth-error-message">{{msg}}</div>
      <div class="d-flex justify--center mt-4">
        <button type="submit" class="auth-btn">Verify OTP</button>
      </div>
      <div class="d-flex justify--center mt-3">
        <router-link class="back-link" :to="{name: 'login'}">← Back to Login</router-link>
      </div>
    </form>

    <form @submit.prevent="resetPassword" v-if="step === 3">
      <div class="auth-title">Set New Password</div>
      <div class="auth-subtext">Choose a strong, secure password for your account.</div>
      
      <va-input
        v-model="password"
        type="password"
        label="New Password"
        :error="!!passwordErrors.length"
        :error-messages="passwordErrors"
        style="color:black!important"
      />
      <va-input
        v-model="confirmPassword"
        type="password"
        label="Confirm Password"
        :error="!!confirmPasswordErrors.length"
        :error-messages="confirmPasswordErrors"
        style="color:black!important"
      />
      <div v-if="msg" class="auth-error-message">{{msg}}</div>
      <div class="d-flex justify--center mt-4">
        <button type="submit" class="auth-btn">Reset Password</button>
      </div>
      <div class="d-flex justify--center mt-3">
        <router-link class="back-link" :to="{name: 'login'}">← Back to Login</router-link>
      </div>
    </form>
  </div>
</template>

<script>
import axios from 'axios'
import VueElementLoading from 'vue-element-loading'

export default {
  name: 'recover-password',
  components: {
    VueElementLoading,
  },
  data () {
    return {
      step: 1,
      visible: false,
      email: '',
      otp: '',
      password: '',
      confirmPassword: '',
      token: '',
      emailErrors: [],
      otpErrors: [],
      passwordErrors: [],
      confirmPasswordErrors: [],
      msg: '',
    }
  },
  methods: {
    sendOtp () {
      this.msg = ''
      this.emailErrors = this.email ? [] : ['Email is required']
      if (this.emailErrors.length > 0) return

      this.visible = true
      axios.post('/admin/password/forget', { email: this.email })
        .then(response => {
          this.visible = false
          if (response.data.status) {
            this.token = response.data.token
            this.step = 2
            this.msg = ''
          } else {
            this.msg = response.data.msg || 'Failed to send OTP'
          }
        })
        .catch(err => {
          this.visible = false
          this.msg = 'An error occurred'
          console.error(err)
        })
    },
    verifyOtp () {
      this.msg = ''
      this.otpErrors = this.otp ? [] : ['OTP is required']
      if (this.otpErrors.length > 0) return

      this.visible = true
      axios.post('/admin/password/otp', { otp: this.otp, token: this.token })
        .then(response => {
          this.visible = false
          if (response.data.status) {
            this.step = 3
            this.msg = ''
          } else {
            this.msg = response.data.msg || 'Invalid OTP'
          }
        })
        .catch(err => {
          this.visible = false
          this.msg = 'An error occurred'
          console.error(err)
        })
    },
    resetPassword () {
      this.msg = ''
      this.passwordErrors = this.password ? [] : ['Password is required']
      this.confirmPasswordErrors = this.confirmPassword ? [] : ['Confirm Password is required']
      if (this.passwordErrors.length > 0 || this.confirmPasswordErrors.length > 0) return

      if (this.password !== this.confirmPassword) {
        this.confirmPasswordErrors = ['Passwords do not match']
        return
      }

      this.visible = true
      axios.post('/admin/password/reset', {
        password: this.password,
        confirmPassword: this.confirmPassword,
        token: this.token,
      })
        .then(response => {
          this.visible = false
          if (response.data.status) {
            this.$router.push({ name: 'login' })
          } else {
            this.msg = response.data.msg || 'Failed to reset password'
          }
        })
        .catch(err => {
          this.visible = false
          this.msg = 'An error occurred'
          console.error(err)
        })
    },
  },
}
</script>

<style lang="scss">
.va-input__container__label {
  color: black !important;
}

.auth-title {
  color: #002c85;
  font-size: 1.4rem;
  font-weight: 700;
  text-align: center;
  margin-bottom: 8px;
}

.auth-subtext {
  color: #7f8c8d;
  font-size: 0.9rem;
  text-align: center;
  line-height: 1.4;
  margin-bottom: 24px;
}

.auth-btn {
  background: linear-gradient(135deg, #002c85 0%, #001a54 100%) !important;
  color: white !important;
  border: none;
  padding: 10px 32px;
  font-size: 0.95rem;
  font-weight: 600;
  border-radius: 24px;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 44, 133, 0.2);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  outline: none;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 44, 133, 0.35);
    background: linear-gradient(135deg, #0037a5 0%, #002c85 100%) !important;
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 8px rgba(0, 44, 133, 0.2);
  }
}

.back-link {
  color: #7f8c8d !important;
  font-size: 0.9rem;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s ease;
  padding: 4px 8px;
  border-radius: 4px;

  &:hover {
    color: #002c85 !important;
    background-color: rgba(0, 44, 133, 0.05);
    text-decoration: none;
  }
}

.auth-error-message {
  color: #e34b4a;
  font-size: 0.85rem;
  text-align: center;
  font-weight: 500;
  background-color: rgba(227, 75, 74, 0.1);
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid rgba(227, 75, 74, 0.2);
  margin-top: 12px;
  margin-bottom: 12px;
}
</style>
